import styled from 'styled-components';

export const PaginationRow = styled.div`
	display: flex;
	justify-content: end;
`;

export const Title = styled.h2`
	margin: 0;
	font-size: 40px;
	line-height: 47px;
	font-weight: 700;
	color: ${({ theme }) => theme.colors.text.title};
`;
